/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'doctrine/admiral_3': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M28 19.354L31.354 16 28 12.646V4h-8.646L16 .646 12.646 4H4v8.646L.646 16 4 19.354V28h8.646L16 31.354 19.354 28H28v-8.646zM30.646 16L28 18.646v-5.293L30.646 16zM16 1.354L18.646 4h-5.293L16 1.354zM1.354 16L4 13.354v5.292L1.354 16zM16 30.646L13.354 28h5.292L16 30.646zM26 26H6V6h20v20z"/><circle pid="1" cx="16" cy="18.4" r="1"/><path pid="2" d="M4 4v24h24V4H4zm17.1 15.889l-.355.356-1.23 1.231-.164.164.315.676a.5.5 0 11-.906.422l-.161-.346-2.636 2.637-2.569-2.569-.094.255a.501.501 0 01-.94-.344l.253-.691-.256-.256-1.27-1.27-.187-.183v-.922l1.836 1.836.961.961 2.264 2.264 2.242-2.243.941-.942 1.955-1.953v.917h.001zM13.5 18.4a2.499 2.499 0 115 0 2.5 2.5 0 01-5 0zm6.178-2.304l-3.611-3.551-3.66 3.597-5.176-3.38h7.104l1.658-5.879 1.821 5.879h6.955l-5.091 3.334z"/>'
  }
})
